import { Component, OnInit, Input, ChangeDetectorRef, Output, EventEmitter, Inject, LOCALE_ID } from '@angular/core';
import { LetterToBoardService, LetterOnBoard } from '@schoolbelle/api/letter-to-board';
import { LetterService } from '@schoolbelle/api/letter';
import { GroupService } from '@schoolbelle/api/group';
import { BoardService } from '@schoolbelle/api/board';
import { filter, finalize, map, share, tap } from 'rxjs/operators';
import { get, reduce, merge } from 'lodash-es';
import { Observable, Subscription, throwError } from 'rxjs';
import { AuthService } from '@schoolbelle/api/auth';
import { InfiniteListService } from '@schoolbelle/common/infinite-list';
@Component({
  template: '',
})
export class LetterItemComponent implements OnInit {
  public infinite:InfiniteListService;  

  @Input() item:LetterOnBoard;
  @Input() query:string; // query string for highlight
  @Input() isInView:boolean = false;

  @Input() fixedAtTop:boolean = false;
  @Output() fixAtTop = new EventEmitter<number>();  

  title:string|{[lang:string]:string};
  content:string|{[lang:string]:string};
  usedLangs:string[];
  currentLang:string;

  subscription = new Subscription();
  get reserved ():boolean {
    return this.item && this.item.issue_at && this.item.issue_at * 1000 > new Date().getTime();
  }
  permission:string;
  constructor(
    protected auth:AuthService,
    public group:GroupService,
    public board:BoardService,
    protected ltb:LetterToBoardService,
    protected letter:LetterService,
    protected cdRef:ChangeDetectorRef,
    @Inject(LOCALE_ID) protected locale_id:string,
  ) { 

  }

  handleLanguages () {
    if (this.item.lang && this.item.translations && this.item.translations.length) {
      const usedLangs = [];
      usedLangs.push(this.item.lang, ...this.item.translations.map(t=>t.lang));
      this.usedLangs = usedLangs;
      this.title = reduce(this.item.translations, (acc, t)=>{ return {...acc, [t.lang]:t.title} }, {[this.item.lang]:this.item.title});
      this.content = reduce(this.item.translations, (acc, t)=>{ return {...acc, [t.lang]:t.content} }, {[this.item.lang]:this.item.content});

      const myLang = this.auth.currentUser && this.auth.currentUser.lang || this.locale_id.slice(0,2);
      if (this.usedLangs.includes(myLang)) this.currentLang = myLang;
      else this.currentLang = this.usedLangs[0];
    }
    else {
      this.title = this.item.title
      this.content = this.item.content;


    } 
  }

  ngOnInit() {
    this.handleLanguages();
    if (this.infinite) this.subscription.add(
      this.infinite.onListChange.pipe(
        map(e=>({
          ltg_id:get(e, ['data', 'n', 'ltg_id']),
          type:e.type,
          item:get(e, ['data', 'n']),          
        })),
        filter(({ltg_id, type})=>type === 'replace' && this.item.ltg_id === ltg_id),
      )
      .subscribe((e)=>{
        this.set(e.item);
      })   
    )    
  }
  ngOnDestroy () {
    this.subscription.unsubscribe();
  }


   
  refresh () {
    const ob = this.ltb.fetch({type:this.item.type, ltg_id:this.item.ltg_id}).pipe(
      map(list=>list[0]),
      map(item=>{
        // this.set(item);
        if (this.infinite) {
          const index = this.infinite.replace(this.infinite.list.find(item=>item.ltg_id === this.item.ltg_id), item);
          return this.infinite.list[index];
        }  
        else {
          return item;
        }
      }),
      tap((item)=>this.set(item)),
      share(),
    )
    ob.subscribe();
    return ob;
  }
  update (data:{[key:string]:any}) {
    this.set(merge({}, this.item, data))
  }  
  set (item:LetterOnBoard) {
    this.item = item;
    this.handleLanguages();
    this.cdRef.detectChanges();
  }
  
  

  delete (item:LetterOnBoard) {
    let ob:Observable<any>;
    if (this.group && item.user_id === this.group.currentGroup.uid || this.group.checkPermission('schooladmin')) {
      ob = this.deleteFromAllLetterTargets(item);
    } else {
      ob = this.deleteFromCurrentLetterTarget(item);
    }    
    ob = ob.pipe(share());
    ob.subscribe();
    return ob;
  }

  protected deleteFromAllLetterTargets (item:LetterOnBoard) {
    return this.letter.remove({letter_id:item.letter_id})
  }
  protected deleteFromCurrentLetterTarget (item:LetterOnBoard) {
    return this.ltb.remove({ltg_id:item.ltg_id})
  } 




  canFixAtTop ():boolean {
    return (!this.group.currentGroup.sid && this.group.checkPermission('admin')) ||
    ((this.group.currentGroup.subtype === 'school' && this.group.checkPermission('schooladmin')))     
  }  


  // [START flag system]
  flagToggling:boolean = false;
  viewAnyways:boolean = false;
  flag (comment?:string) {
    if (this.flagToggling) return throwError(new Error('Already toggling...'));
    const total = (get(this.item, ['stickers', 'flag', 'total']) || 0) + 1;
    const clicked = true;
    this.update({stickers:{flag:{total, clicked}}});
    this.flagToggling = true;
    return this.ltb.flag({ltg_id:this.item.ltg_id, comment})
    .pipe(finalize(()=>{
      this.flagToggling = false;
      this.cdRef.detectChanges();
    }));
  }
  unflag () {
    if (this.flagToggling) return throwError(new Error('Already toggling...'));
    const total = (get(this.item, ['stickers', 'flag', 'total']) || 0) - 1;
    const clicked = false;
    this.update({stickers:{flag:{total, clicked}}});
    this.flagToggling = true;
    return this.ltb.unflag({ltg_id:this.item.ltg_id})
    .pipe(finalize(()=>{
      this.flagToggling = false;
      this.cdRef.detectChanges();
    }));
  } 
  clearFlags () {
    if (this.flagToggling) return throwError(new Error('Already toggling...'));
    const total = 0;;
    const clicked = false;
    this.update({stickers:{flag:{total, clicked}}});
    this.flagToggling = true;
    return this.ltb.clearflags({letter_id:this.item.letter_id})
    .pipe(finalize(()=>{
      this.flagToggling = false;
      this.cdRef.detectChanges();
    }));

  }

  report (comment?:string) {
    if (this.flagToggling) return throwError(new Error('Already toggling...'));
    this.update({user_reported:true});
    this.flagToggling = true;
    return this.auth.report({reportee_user_id:this.item.user_id, comment})
    .pipe(
      finalize(()=>{
        this.flagToggling = false;
        this.cdRef.detectChanges();
      }),
    );
  }
  unreport () {
    if (this.flagToggling) return throwError(new Error('Already toggling...'));
    this.update({user_reported:false});
    this.flagToggling = true;
    return this.auth.unreport({reportee_user_id:this.item.user_id})
    .pipe(
      finalize(()=>{
        this.flagToggling = false;
        this.cdRef.detectChanges();
      }),
    );
  }

  get blinded ():boolean {
    const total = get(this.item, ['stickers', 'flag', 'total']) || 0;
    const clicked = get(this.item, ['stickers', 'flag', 'clicked']) || false;
    if (this.viewAnyways) return false;
    if (this.item.user_reported) return true;
    if (clicked) return true;
    if (total >= 3) return true;
    return false;
  }
  // [START flag system]
  
}
